import { useEffect, useMemo, useState } from "react";

import mrGestorLogo from "../assets/mrgestor-logo.png";
import heroInstructores from "../assets/hero-instructores.png";
import mockupDocumental from "../assets/mockup-documental.png";
import familiaImg from "../assets/familia.png";
import equipoImg from "../assets/equipo.png";
import oficinaImg from "../assets/oficina.png";
import escritorioImg from "../assets/escritorio.png";
import logoBlancoFooter from "../assets/logoBlanco_piedepagina.png";
import logoIcs from "../assets/logo_ics_ingenieria colombiana de sistemas.png";

import "./landing.css";

export default function LandingPage() {
  const [activeSection, setActiveSection] = useState("inicio");
  const [formMessage, setFormMessage] = useState("");

  const whatsappUrl = useMemo(
    () =>
      "https://wa.me/573177089554?text=" +
      encodeURIComponent("Hola, quiero conocer más sobre MrGestor."),
    []
  );

  const scrollToSection = (sectionId) => {
    const isResponsive = window.matchMedia("(max-width: 920px)").matches;
    const targetId =
      isResponsive && sectionId === "inicio" ? "soluciones" : sectionId;

    const section = document.getElementById(targetId);

    if (!section) return;

    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    setActiveSection(targetId);

    window.history.replaceState(
      null,
      "",
      `${window.location.pathname}${window.location.search}`
    );
  };

  useEffect(() => {
    document.title = "MrGestor | Gestión documental para Instructores Contratistas";

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content =
      "MrGestor: gestión documental inteligente para Instructores Contratistas. Agendas, legalizaciones, cuentas de cobro, informes, evidencias y seguimiento.";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mg-is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    const revealElements = document.querySelectorAll(".mg-landing-page .mg-reveal");
    revealElements.forEach((element) => observer.observe(element));

    const sectionElements = document.querySelectorAll(
      ".mg-landing-page section[id]"
    );

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (visibleEntry?.target?.id) {
          setActiveSection(visibleEntry.target.id);
        }
      },
      {
        rootMargin: "-35% 0px -50% 0px",
        threshold: [0.1, 0.25, 0.5],
      }
    );

    sectionElements.forEach((section) => sectionObserver.observe(section));

    const handleScroll = () => {
      const header = document.getElementById("siteHeader");
      header?.classList.toggle("mg-is-scrolled", window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      observer.disconnect();
      sectionObserver.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const data = new FormData(form);

    const name = String(data.get("name") || "").trim();
    const email = String(data.get("email") || "").trim();
    const phone = String(data.get("phone") || "").trim();

    if (!name || !email || !phone) {
      setFormMessage("Completa los campos obligatorios.");
      return;
    }

    setFormMessage(
      "Solicitud registrada. Conecta este formulario con tu API para guardarla y enviar la notificación."
    );
    form.reset();
  }

  return (
    <div className="mg-landing-page">
      <button type="button" className="mg-skip-link" onClick={() => scrollToSection("inicio")}>
        Saltar al contenido principal
      </button>
      <div className="mg-topbar" id="mg-topbar">
        <div className="mg-container mg-topbar__inner">
          <p>
            <strong>
              MrGestor
            </strong>
            | Gestión documental inteligente para Instructores Contratistas
          </p>
          <button type="button" onClick={() => scrollToSection("contacto")}>
            Solicitar demo
          </button>
        </div>
      </div>
      <header className="mg-site-header" id="siteHeader">
        <nav className="mg-container mg-nav" aria-label="Navegación principal">
          <button
            type="button"
            className="mg-brand"
            aria-label="Ir al inicio de MrGestor"
            onClick={() => scrollToSection("inicio")}
          >
            <img src={mrGestorLogo} alt="Logo MrGestor" loading="eager" />
          </button>

          <div className="mg-nav-menu" id="navMenu">
            <button
              type="button"
              className={`mg-nav-link ${activeSection === "inicio" ? "mg-active" : ""
                }`}
              onClick={() => scrollToSection("inicio")}
            >
              Inicio
            </button>

            <button
              type="button"
              className={`mg-nav-link ${activeSection === "soluciones" ? "mg-active" : ""
                }`}
              onClick={() => scrollToSection("soluciones")}
            >
              Soluciones
            </button>

            <button
              type="button"
              className={`mg-nav-link ${activeSection === "modulos" ? "mg-active" : ""
                }`}
              onClick={() => scrollToSection("modulos")}
            >
              Módulos
            </button>

            <button
              type="button"
              className={`mg-nav-link ${activeSection === "legalizaciones" ? "mg-active" : ""
                }`}
              onClick={() => scrollToSection("legalizaciones")}
            >
              Legalizaciones
            </button>

            <button
              type="button"
              className={`mg-nav-link ${activeSection === "experiencia" ? "mg-active" : ""
                }`}
              onClick={() => scrollToSection("experiencia")}
            >
              Experiencia
            </button>

            {/*
            <button
              type="button"
              className={`mg-nav-link ${
                activeSection === "planes" ? "mg-active" : ""
              }`}
              onClick={() => scrollToSection("planes")}
            >
              Planes
            </button>
            */}

            <button
              type="button"
              className={`mg-nav-link ${activeSection === "contacto" ? "mg-active" : ""
                }`}
              onClick={() => scrollToSection("contacto")}
            >
              Contacto
            </button>

          </div>

          <div className="mg-nav-actions">
            <a className="mg-btn mg-btn--outline-dark" href="/login">
              Ingresar
            </a>

            <button
              type="button"
              className="mg-btn mg-btn--primary"
              onClick={() => scrollToSection("contacto")}
            >
              Solicitar demo
            </button>
          </div>

          <a
            className="mg-mobile-login"
            href="/login"
            aria-label="Ingresar a MrGestor"
          >
            Ingresar
          </a>

        </nav>
      </header>
      <main id="contenido-principal">
        <section className="mg-notice-band">
          <div className="mg-container mg-notice-band__grid">
            <strong>
              Para Instructores Contratistas
            </strong>
            <span>
              Organiza, centraliza y controla tu gestión documental mensual.
            </span>
            <button type="button" onClick={() => scrollToSection("soluciones")}>
              Conocer solución
            </button>
          </div>
        </section>
        <section className="mg-hero" id="inicio">
          <div className="mg-hero__panel mg-reveal">
            <h1>
              Gestiona tus documentos como nunca antes
            </h1>
            <p>
              MrGestor centraliza agendas, legalizaciones, cuentas de cobro, informes,
              evidencias y seguimiento en una experiencia institucional, moderna y fácil de usar.
            </p>
            <div className="mg-hero__actions">
              <button type="button" className="mg-btn mg-btn--primary" onClick={() => scrollToSection("contacto")}>
                Solicitar demo
              </button>
              <button type="button" className="mg-btn mg-btn--outline-blue" onClick={() => scrollToSection("modulos")}>
                Ver módulos
              </button>
            </div>
          </div>
          <div className="mg-hero__image mg-reveal">
            <img
              src={heroInstructores}
              alt="Equipo de trabajo revisando información documental"
              loading="eager"
              fetchPriority="high"
            />
          </div>
        </section>
        <section className="mg-section mg-section--light" id="soluciones">
          <div className="mg-container">
            <div className="mg-section-heading mg-reveal">
              <h2>
                Soluciones para una gestión documental más eficiente
              </h2>
              <p>
                Centraliza la información, organiza tus procesos y realiza el seguimiento
                de cada documento desde una plataforma diseñada para simplificar la
                gestión administrativa de los instructores.
              </p>
            </div>
            <div className="mg-solutions-grid">
              <article className="mg-solution-card mg-reveal">
                <div className="mg-solution-card__top">
                  <div className="mg-solution-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M4 19.5V6.5A2.5 2.5 0 0 1 6.5 4H10l2 2h5.5A2.5 2.5 0 0 1 20 8.5v11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                      <path d="M8 12h8M8 15.5h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                    </svg>
                  </div>
                  <span className="mg-solution-number">
                    01
                  </span>
                </div>
                <div className="mg-solution-card__content">
                  <h3>
                    Gestión documental centralizada
                  </h3>
                  <p>
                    Registra, actualiza y consulta la información relacionada con tus
                    procesos desde un único entorno. Reduce la dispersión de archivos,
                    mejora la organización documental y facilita el acceso oportuno a
                    los documentos que necesitas.
                  </p>
                </div>
                <div className="mg-solution-card__footer">
                  <span>
                    Organización y control documental
                  </span>
                </div>
              </article>
              <article className="mg-solution-card mg-reveal">
                <div className="mg-solution-card__top">
                  <div className="mg-solution-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M8.5 12.5 13 8a3 3 0 0 1 4.25 4.25l-6.5 6.5a5 5 0 0 1-7.07-7.07l7-7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  <span className="mg-solution-number">
                    02
                  </span>
                </div>
                <div className="mg-solution-card__content">
                  <h3>
                    Evidencias y soportes organizados
                  </h3>
                  <p>
                    Adjunta fotografías, archivos, comprobantes y observaciones a cada
                    registro. Mantén los soportes relacionados con el proceso
                    correspondiente para facilitar su consulta, revisión, verificación
                    y presentación cuando sean requeridos.
                  </p>
                </div>
                <div className="mg-solution-card__footer">
                  <span>
                    Soportes vinculados al proceso
                  </span>
                </div>
              </article>
              <article className="mg-solution-card mg-reveal">
                <div className="mg-solution-card__top">
                  <div className="mg-solution-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M4 18V9M10 18V5M16 18v-7M22 18V3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                      <path d="m4 7 6-4 6 5 6-6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  <span className="mg-solution-number">
                    03
                  </span>
                </div>
                <div className="mg-solution-card__content">
                  <h3>
                    Seguimiento de procesos
                  </h3>
                  <p>
                    Consulta estados, actividades pendientes y avances registrados de
                    manera organizada. Obtén una visión clara de cada proceso y reduce
                    el tiempo destinado a revisar diferentes archivos, carpetas o
                    herramientas de trabajo.
                  </p>
                </div>
                <div className="mg-solution-card__footer">
                  <span>
                    Control de avances y pendientes
                  </span>
                </div>
              </article>
              <article className="mg-solution-card mg-reveal">
                <div className="mg-solution-card__top">
                  <div className="mg-solution-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7"></rect>
                      <path d="M8 3v4M16 3v4M3 10h18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                      <path d="m8 15 2 2 5-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  <span className="mg-solution-number">
                    04
                  </span>
                </div>
                <div className="mg-solution-card__content">
                  <h3>
                    Planeación de agendas
                  </h3>
                  <p>
                    Organiza actividades, fechas, desplazamientos y compromisos de forma
                    estructurada. Conserva la relación entre lo programado, lo ejecutado
                    y las evidencias asociadas a cada actividad o proceso registrado.
                  </p>
                </div>
                <div className="mg-solution-card__footer">
                  <span>
                    Planeación y trazabilidad
                  </span>
                </div>
              </article>
              <article className="mg-solution-card mg-reveal">
                <div className="mg-solution-card__top">
                  <div className="mg-solution-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M6 3h8l4 4v14H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                      <path d="M14 3v5h5M8 13h8M8 17h6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                    </svg>
                  </div>
                  <span className="mg-solution-number">
                    05
                  </span>
                </div>
                <div className="mg-solution-card__content">
                  <h3>
                    Consolidación de informes
                  </h3>
                  <p>
                    Integra actividades, resultados, observaciones y soportes en
                    documentos estructurados. Mejora la presentación de la información
                    y reduce el tiempo dedicado a elaborar informes de manera manual.
                  </p>
                </div>
                <div className="mg-solution-card__footer">
                  <span>
                    Información consolidada
                  </span>
                </div>
              </article>
              <article className="mg-solution-card mg-reveal">
                <div className="mg-solution-card__top">
                  <div className="mg-solution-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M5 3h10l4 4v14H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                      <path d="M15 3v5h5" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                      <path d="m8 15 2 2 5-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  <span className="mg-solution-number">
                    06
                  </span>
                </div>
                <div className="mg-solution-card__content">
                  <h3>
                    Autorizaciones y validaciones
                  </h3>
                  <p>
                    Gestiona aceptaciones, autorizaciones y validaciones relacionadas
                    con los documentos del proceso. Conserva un registro verificable de
                    cada aprobación y fortalece la trazabilidad documental.
                  </p>
                </div>
                <div className="mg-solution-card__footer">
                  <span>
                    Validación y trazabilidad documental
                  </span>
                </div>
              </article>
            </div>
          </div>
        </section>
        <section className="mg-section mg-modules-panel-section" id="modulos">
          <div className="mg-container">
            <div className="mg-modules-panel-heading mg-reveal">
              <span className="mg-section-kicker">
                Módulos integrados
              </span>
              <h2>
                Herramientas conectadas para una gestión más organizada
              </h2>
              <p>
                Cada módulo de MrGestor se integra dentro de un mismo flujo de trabajo
                para centralizar información, reducir reprocesos y facilitar el control
                documental de principio a fin.
              </p>
            </div>
            <div className="mg-modules-panel mg-reveal">
              <div className="mg-modules-panel__left">
                <article className="mg-module-line mg-active">
                  <span className="mg-module-line__number">
                    01
                  </span>
                  <div className="mg-module-line__content">
                    <div className="mg-module-line__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.7"></rect>
                        <path d="M8 3v4M16 3v4M3 10h18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                        <path d="m8 15 2 2 5-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </div>
                    <div>
                      <h3>
                        Agendas
                      </h3>
                      <p>
                        Planea actividades, fechas, desplazamientos y compromisos,
                        manteniendo un registro organizado de lo programado y ejecutado.
                      </p>
                    </div>
                  </div>
                </article>
                <article className="mg-module-line">
                  <span className="mg-module-line__number">
                    02
                  </span>
                  <div className="mg-module-line__content">
                    <div className="mg-module-line__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M8.5 12.5 13 8a3 3 0 0 1 4.25 4.25l-6.5 6.5a5 5 0 0 1-7.07-7.07l7-7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </div>
                    <div>
                      <h3>
                        Legalizaciones
                      </h3>
                      <p>
                        Organiza soportes, evidencias, comprobantes y observaciones
                        asociados a cada proceso de legalización.
                      </p>
                    </div>
                  </div>
                </article>
                <article className="mg-module-line">
                  <span className="mg-module-line__number">
                    03
                  </span>
                  <div className="mg-module-line__content">
                    <div className="mg-module-line__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M6 3h8l4 4v14H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                        <path d="M14 3v5h5M8 12h8M8 16h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                        <path d="M8 8h2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                      </svg>
                    </div>
                    <div>
                      <h3>
                        Cuentas de cobro
                      </h3>
                      <p>
                        Registra valores, fechas, periodos y estados para mantener mayor
                        control sobre la elaboración y seguimiento de cada cuenta.
                      </p>
                    </div>
                  </div>
                </article>
                <article className="mg-module-line">
                  <span className="mg-module-line__number">
                    04
                  </span>
                  <div className="mg-module-line__content">
                    <div className="mg-module-line__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M6 3h8l4 4v14H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                        <path d="M14 3v5h5M8 13h8M8 17h6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                      </svg>
                    </div>
                    <div>
                      <h3>
                        Informes
                      </h3>
                      <p>
                        Consolida actividades, resultados, observaciones y soportes en
                        documentos estructurados para revisión y presentación.
                      </p>
                    </div>
                  </div>
                </article>
                <article className="mg-module-line">
                  <span className="mg-module-line__number">
                    05
                  </span>
                  <div className="mg-module-line__content">
                    <div className="mg-module-line__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M5 3h10l4 4v14H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                        <path d="M15 3v5h5" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                        <path d="m8 15 2 2 5-5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </div>
                    <div>
                      <h3>
                        Firmas y validaciones
                      </h3>
                      <p>
                        Gestiona aceptaciones, autorizaciones y validaciones documentales,
                        conservando evidencia de cada aprobación realizada.
                      </p>
                    </div>
                  </div>
                </article>
                <article className="mg-module-line">
                  <span className="mg-module-line__number">
                    06
                  </span>
                  <div className="mg-module-line__content">
                    <div className="mg-module-line__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M4 18V9M10 18V5M16 18v-7M22 18V3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                        <path d="m4 7 6-4 6 5 6-6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </div>
                    <div>
                      <h3>
                        Seguimiento
                      </h3>
                      <p>
                        Consulta avances, actividades pendientes y estados de cada proceso
                        para mantener una trazabilidad clara de la gestión.
                      </p>
                    </div>
                  </div>
                </article>
              </div>
              <div className="mg-modules-panel__right">
                <div className="mg-module-preview">
                  <div className="mg-module-preview__top">
                    <div className="mg-module-preview__icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="M4 19.5V6.5A2.5 2.5 0 0 1 6.5 4H10l2 2h5.5A2.5 2.5 0 0 1 20 8.5v11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M8 12h8M8 15.5h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                      </svg>
                    </div>
                    <span className="mg-module-preview__label">
                      Flujo centralizado
                    </span>
                  </div>
                  <h3>
                    Todo tu proceso documental en un solo entorno
                  </h3>
                  <p>
                    MrGestor conecta agendas, legalizaciones, cuentas de cobro, informes,
                    evidencias y validaciones dentro de una misma ruta de trabajo. Esto
                    permite consultar la información con mayor facilidad, conservar la
                    trazabilidad y reducir la dispersión entre archivos y herramientas.
                  </p>
                  <div className="mg-module-preview__features">
                    <div className="mg-module-preview__feature">
                      <span aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="m6 12 4 4 8-8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </span>
                      <p>
                        Información centralizada y disponible para consulta.
                      </p>
                    </div>
                    <div className="mg-module-preview__feature">
                      <span aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="m6 12 4 4 8-8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </span>
                      <p>
                        Documentos relacionados dentro de un mismo proceso.
                      </p>
                    </div>
                    <div className="mg-module-preview__feature">
                      <span aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="m6 12 4 4 8-8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </span>
                      <p>
                        Mayor control sobre avances, pendientes y validaciones.
                      </p>
                    </div>
                  </div>
                  <div className="mg-module-preview__stats">
                    <div className="mg-module-preview__stat">
                      <strong>
                        6
                      </strong>
                      <small>
                        Módulos integrados
                      </small>
                    </div>
                    <div className="mg-module-preview__stat">
                      <strong>
                        24/7
                      </strong>
                      <small>
                        Consulta disponible
                      </small>
                    </div>
                    <div className="mg-module-preview__stat">
                      <strong>
                        1
                      </strong>
                      <small>
                        Flujo de trabajo
                      </small>
                    </div>
                  </div>
                  <button type="button" className="mg-btn mg-btn--primary" onClick={() => scrollToSection("contacto")}>
                    Solicitar demostración
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="mg-section mg-split-section" id="legalizaciones">
          <div className="mg-container mg-split-grid">
            <div className="mg-split-copy mg-reveal">
              <h2>
                Cada agenda puede tener su legalización relacionada
              </h2>
              <p>
                MrGestor permite asociar múltiples evidencias fotográficas por día,
                soportes documentales y observaciones para mantener trazabilidad.
              </p>
              <div className="mg-check-list">
                <span>
                  ✓ Evidencias fotográficas por día
                </span>
                <span>
                  ✓ Soportes y archivos asociados
                </span>
                <span>
                  ✓ Estado documental visible
                </span>
              </div>
            </div>
            <div className="mg-mockup-card mg-reveal">
              <img
                src={mockupDocumental}
                alt="Vista conceptual de una legalización en MrGestor"
                loading="lazy"
              />
            </div>
          </div>
        </section>
        <section className="mg-section mg-section--light" id="proceso">
          <div className="mg-container">
            <div className="mg-section-heading mg-reveal">
              <h2>
                De la información al documento final
              </h2>
              <p>
                Transforma los datos de tu gestión en documentos organizados mediante
                un proceso claro, conectado y fácil de controlar.
              </p>
            </div>
            <div className="mg-steps-grid">
              <article className="mg-step-card mg-reveal">
                <span>
                  01
                </span>
                <h3>
                  Registra la información
                </h3>
                <p>
                  Ingresa actividades, fechas, observaciones, datos y soportes
                  relacionados con cada proceso desde un entorno centralizado.
                </p>
              </article>
              <article className="mg-step-card mg-reveal">
                <span>
                  02
                </span>
                <h3>
                  Relaciona los procesos
                </h3>
                <p>
                  Vincula agendas, legalizaciones, evidencias, cuentas de cobro e
                  informes para mantener la información correctamente conectada.
                </p>
              </article>
              <article className="mg-step-card mg-reveal">
                <span>
                  03
                </span>
                <h3>
                  Genera los documentos
                </h3>
                <p>
                  Consolida la información registrada en documentos claros,
                  estructurados y preparados para su revisión o presentación.
                </p>
              </article>
              <article className="mg-step-card mg-reveal">
                <span>
                  04
                </span>
                <h3>
                  Controla y realiza seguimiento
                </h3>
                <p>
                  Consulta estados, avances, pendientes y observaciones para conservar
                  la trazabilidad de cada documento y actividad.
                </p>
              </article>
            </div>
          </div>
        </section>
        <section className="mg-section mg-experience-section" id="experiencia">
          <div className="mg-container">
            <div className="mg-experience-heading mg-reveal">
              <div>
                <span className="mg-section-kicker">
                  Una experiencia más eficiente
                </span>
                <h2>
                  Simplifica tu gestión y recupera tiempo para lo que realmente importa
                </h2>
              </div>
              <p>
                MrGestor transforma tareas documentales dispersas en un flujo de trabajo
                organizado, permitiéndote avanzar con mayor claridad, control y tranquilidad.
              </p>
            </div>
            <div className="mg-experience-layout">
              <article className="mg-experience-feature mg-reveal">
                <div className="mg-experience-feature__image">
                  <img src={familiaImg} alt="Familia compartiendo tiempo de calidad" loading="lazy" />
                  <span className="mg-experience-feature__badge">
                    Bienestar y equilibrio
                  </span>
                </div>
                <div className="mg-experience-feature__content">
                  <div className="mg-experience-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none">
                      <path d="M12 21s-7-4.35-9.2-8.6C1.2 9.3 2.7 5.5 6.3 4.7c2.1-.5 4.2.4 5.7 2 1.5-1.6 3.6-2.5 5.7-2 3.6.8 5.1 4.6 3.5 7.7C19 16.65 12 21 12 21Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                    </svg>
                  </div>
                  <span className="mg-experience-eyebrow">
                    Más tiempo para ti
                  </span>
                  <h3>
                    Reduce la carga administrativa y mejora el equilibrio de tu día
                  </h3>
                  <p>
                    Centralizar la información y disminuir los reprocesos te permite
                    dedicar menos tiempo a tareas repetitivas y más espacio a tu familia,
                    tu descanso y tus proyectos personales.
                  </p>
                  <div className="mg-experience-feature__benefits">
                    <span>
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="m6 12 4 4 8-8" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                      Menos tareas repetitivas
                    </span>
                    <span>
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="m6 12 4 4 8-8" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                      Mayor tranquilidad
                    </span>
                    <span>
                      <svg viewBox="0 0 24 24" fill="none">
                        <path d="m6 12 4 4 8-8" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                      Mejor aprovechamiento del tiempo
                    </span>
                  </div>
                </div>
              </article>
              <div className="mg-experience-cards">
                <article className="mg-experience-card mg-reveal">
                  <div className="mg-experience-card__image">
                    <img src={equipoImg} alt="Equipo de profesionales trabajando de forma colaborativa" loading="lazy" />
                  </div>
                  <div className="mg-experience-card__content">
                    <div className="mg-experience-card__header">
                      <div className="mg-experience-card__icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                          <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.7"></circle>
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                        </svg>
                      </div>
                      <span>
                        Colaboración
                      </span>
                    </div>
                    <h3>
                      Información clara para una mejor coordinación
                    </h3>
                    <p>
                      Facilita la consulta de actividades, avances y documentos para
                      mejorar la comunicación entre las personas involucradas.
                    </p>
                  </div>
                </article>
                <article className="mg-experience-card mg-reveal">
                  <div className="mg-experience-card__image">
                    <img src={oficinaImg} alt="Profesional trabajando con información organizada" loading="lazy" />
                  </div>
                  <div className="mg-experience-card__content">
                    <div className="mg-experience-card__header">
                      <div className="mg-experience-card__icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M4 19.5V6.5A2.5 2.5 0 0 1 6.5 4H10l2 2h5.5A2.5 2.5 0 0 1 20 8.5v11" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"></path>
                          <path d="M8 12h8M8 15.5h5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"></path>
                        </svg>
                      </div>
                      <span>
                        Control documental
                      </span>
                    </div>
                    <h3>
                      Encuentra la información cuando la necesitas
                    </h3>
                    <p>
                      Mantén soportes, legalizaciones, cuentas de cobro e informes
                      centralizados dentro de un mismo entorno.
                    </p>
                  </div>
                </article>
                <article className="mg-experience-card mg-experience-card--horizontal mg-reveal">
                  <div className="mg-experience-card__image">
                    <img src={escritorioImg} alt="Espacio de trabajo con documentos organizados digitalmente" loading="lazy" />
                  </div>
                  <div className="mg-experience-card__content">
                    <div className="mg-experience-card__header">
                      <div className="mg-experience-card__icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                          <path d="M4 13h6V3H4v10ZM14 21h6V11h-6v10ZM14 3v4h6V3h-6ZM4 21h6v-4H4v4Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round"></path>
                        </svg>
                      </div>
                      <span>
                        Productividad diaria
                      </span>
                    </div>
                    <h3>
                      Convierte tareas dispersas en un flujo de trabajo organizado
                    </h3>
                    <p>
                      Gestiona la información con mayor continuidad y reduce el tiempo
                      invertido en buscar, ordenar y reconstruir documentos.
                    </p>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </section>

        {/* 
        <section className="mg-section mg-section--light" id="planes">
          <div className="mg-container">
            <div className="mg-section-heading mg-reveal">
              <span className="mg-section-kicker">
                Planes MrGestor
              </span>
              <h2>
                Elige el periodo que mejor se adapte a ti
              </h2>
              <p>
                Todos los planes incluyen las mismas funciones. La diferencia está en
                la duración del acceso y el ahorro obtenido.
              </p>
            </div>
            <div className="mg-pricing-grid">
              <article className="mg-price-card mg-reveal">
                <div className="mg-price-card__header">
                  <span className="mg-price-tag">
                    Inicio flexible
                  </span>
                  <h3>
                    Plan Bimestral
                  </h3>
                  <p>
                    Acceso durante dos meses para organizar y gestionar tus documentos.
                  </p>
                </div>
                <div className="mg-price-card__price">
                  <strong>
                    $90.000
                  </strong>
                  <span>
                    COP / 2 meses
                  </span>
                </div>
                <div className="mg-price-summary">
                  <strong>
                    Ahorras $10.000 COP
                  </strong>
                </div>
                <ul className="mg-price-features">
                  <li>
                    ✓ Agendas y legalizaciones
                  </li>
                  <li>
                    ✓ Evidencias y soportes
                  </li>
                  <li>
                    ✓ Cuentas de cobro e informes
                  </li>
                  <li>
                    ✓ Seguimiento documental
                  </li>
                  <li>
                    ✓ Soporte básico por WhatsApp
                  </li>
                </ul>
                <div className="mg-price-card__note">
                  Recomendado para iniciar y conocer la plataforma.
                </div>
                <button type="button" className="mg-btn mg-btn--outline-dark" onClick={() => scrollToSection("contacto")}>
                  Elegir Plan Bimestral
                </button>
              </article>
              <article className="mg-price-card mg-reveal">
                <div className="mg-price-card__header">
                  <span className="mg-price-tag">
                    Mayor continuidad
                  </span>
                  <h3>
                    Plan Semestral
                  </h3>
                  <p>
                    Seis meses de acceso para mantener una gestión documental continua.
                  </p>
                </div>
                <div className="mg-price-card__price">
                  <strong>
                    $250.000
                  </strong>
                  <span>
                    COP / 6 meses
                  </span>
                </div>
                <div className="mg-price-summary">
                  <strong>
                    Ahorras $50.000 COP
                  </strong>
                </div>
                <ul className="mg-price-features">
                  <li>
                    ✓ Agendas y legalizaciones
                  </li>
                  <li>
                    ✓ Evidencias y soportes
                  </li>
                  <li>
                    ✓ Cuentas de cobro e informes
                  </li>
                  <li>
                    ✓ Seguimiento documental
                  </li>
                  <li>
                    ✓ Soporte básico por WhatsApp
                  </li>
                </ul>
                <div className="mg-price-card__note">
                  Ideal para quienes buscan continuidad y mayor ahorro.
                </div>
                <button type="button" className="mg-btn mg-btn--outline-dark" onClick={() => scrollToSection("contacto")}>
                  Elegir Plan Semestral
                </button>
              </article>
              <article className="mg-price-card mg-featured mg-reveal">
                <span className="mg-badge">
                  Mayor ahorro
                </span>
                <div className="mg-price-card__header">
                  <span className="mg-price-tag">
                    Plan recomendado
                  </span>
                  <h3>
                    Plan Anual
                  </h3>
                  <p>
                    Acceso durante todo el año con el mayor beneficio económico.
                  </p>
                </div>
                <div className="mg-price-card__price">
                  <strong>
                    $480.000
                  </strong>
                  <span>
                    COP / año
                  </span>
                </div>
                <div className="mg-price-summary">
                  <strong>
                    Ahorras $120.000 COP
                  </strong>
                </div>
                <ul className="mg-price-features">
                  <li>
                    ✓ Agendas y legalizaciones
                  </li>
                  <li>
                    ✓ Evidencias y soportes
                  </li>
                  <li>
                    ✓ Cuentas de cobro e informes
                  </li>
                  <li>
                    ✓ Seguimiento documental
                  </li>
                  <li>
                    ✓ Soporte básico por WhatsApp
                  </li>
                </ul>
                <div className="mg-price-card__note">
                  La mejor opción para estabilidad y gestión continua.
                </div>
                <button type="button" className="mg-btn mg-btn--primary" onClick={() => scrollToSection("contacto")}>
                  Elegir Plan Anual
                </button>
              </article>
            </div>
            <div className="mg-pricing-disclaimer mg-reveal">
              <p>
                Todos los planes incluyen el módulo básico de MrGestor. El acompañamiento
                documental personalizado se contrata como servicio adicional.
              </p>
            </div>
          </div>
        </section>
        */}

        <section className="mg-section mg-contact-section" id="contacto">
          <div className="mg-container mg-contact-grid">
            <div className="mg-contact-copy mg-reveal">
              <h2>
                Agenda una demo de MrGestor
              </h2>
              <p>
                Cuéntanos un poco sobre tu gestión documental y te mostraremos cómo MrGestor
                puede ayudarte a organizar agendas, legalizaciones, informes, evidencias y seguimiento.
              </p>
              <div className="mg-contact-benefits">
                <article>
                  <span>
                    ✓
                  </span>
                  <p>
                    Conoce los módulos principales.
                  </p>
                </article>
                <article>
                  <span>
                    ✓
                  </span>
                  <p>
                    Recibe orientación según tu necesidad.
                  </p>
                </article>
                <article>
                  <span>
                    ✓
                  </span>
                  <p>
                    Consulta planes y acompañamiento disponible.
                  </p>
                </article>
              </div>
            </div>
            <form className="mg-contact-form mg-reveal" id="contactForm" onSubmit={handleSubmit}>
              <div className="mg-form-header">
                <h3>
                  Datos para contactarte
                </h3>
                <p>
                  Completa la información y nos comunicaremos contigo.
                </p>
              </div>
              <div className="mg-form-grid">
                <label>
                  Nombre completo
                  <input type="text" name="name" placeholder="Ej: Juan Cardenas" required />
                </label>
                <label>
                  Correo electrónico
                  <input type="email" name="email" placeholder="juancardenas@gmail.com" required />
                </label>
                <label>
                  Teléfono / WhatsApp
                  <input type="tel" name="phone" placeholder="3304289855" required />
                </label>
                <label>
                  Ciudad / Municipio
                  <input type="text" name="city" placeholder="Ej: Medellín, Apartadó, Yarumal" />
                </label>
                <label>
                  Tipo de usuario
                  <select name="userType" required>
                    <option value="">
                      Selecciona una opción
                    </option>
                    <option value="instructor">
                      Instructor contratista
                    </option>
                    <option value="instructor-gestor">
                      Instructor gestor
                    </option>
                    <option value="asesor">
                      Asesor documental
                    </option>
                    <option value="otro">
                      Otro
                    </option>
                  </select>
                </label>
                <label>
                  Necesidad principal
                  <select name="need" required>
                    <option value="">
                      Selecciona una necesidad
                    </option>
                    <option value="agendas">
                      Organizar agendas
                    </option>
                    <option value="legalizaciones">
                      Gestionar legalizaciones
                    </option>
                    <option value="cuentas-cobro">
                      Cuentas de cobro
                    </option>
                    <option value="informes">
                      Informes mensuales
                    </option>
                    <option value="evidencias">
                      Evidencias fotográficas
                    </option>
                    <option value="todo">
                      Todo el proceso documental
                    </option>
                  </select>
                </label>
              </div>
              <label>
                Mensaje
                <textarea name="message" rows="2" placeholder="Ej: Quiero conocer cómo MrGestor me puede ayudar con agendas, legalizaciones e informes..." required></textarea>
              </label>
              <div className="mg-form-check">
                <input type="checkbox" id="terms" name="terms" required />
                <label htmlFor="terms">
                  Acepto ser contactado para recibir información sobre MrGestor.
                </label>
              </div>
              <button className="mg-btn mg-btn--primary mg-btn--full" type="submit">
                Enviar solicitud de demo
              </button>
              <p className="mg-form-message" id="formMessage" role="status">
                {formMessage}
              </p>
            </form>
          </div>
        </section>
      </main>
      <a className="mg-whatsapp" id="whatsappButton" href={whatsappUrl} target="_blank" rel="noopener noreferrer" aria-label="Escribir por WhatsApp">
        💬
      </a>
      <footer className="mg-footer">
        <div className="mg-container mg-footer-grid">
          <div>
            <img src={logoBlancoFooter} alt="Logo MrGestor" loading="lazy" />
            <p>
              Gestión documental inteligente para Instructores Contratistas.
            </p>
          </div>
          <nav aria-label="Enlaces de pie de página">
            <button type="button" onClick={() => scrollToSection("soluciones")}>
              Soluciones
            </button>
            <button type="button" onClick={() => scrollToSection("modulos")}>
              Módulos
            </button>
            <button type="button" onClick={() => scrollToSection("experiencia")}>
              Experiencia
            </button>
            <button type="button" onClick={() => scrollToSection("planes")}>
              Planes
            </button>
            <button type="button" onClick={() => scrollToSection("contacto")}>
              Contacto
            </button>
          </nav>
        </div>
        <div className="mg-footer-bottom">
          <div className="mg-container mg-footer-bottom__content">
            <div className="mg-footer-bottom__brand">
              <img
                src={logoIcs}
                alt="Logo iCS Ingeniería Colombiana de Sistemas"
                className="mg-footer-bottom__logo"
                loading="lazy"
              />
              <p>
                © 2026 MrGestor. Desarrollado por
                <br />
                <strong>
                  iCS - Ingeniería Colombiana de Sistemas
                </strong>
                .
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}